import { render } from "./Title.vue?vue&type=template&id=ac555f04&scoped=true"
const script = {}

import "./Title.vue?vue&type=style&index=0&id=ac555f04&lang=scss&scoped=true"

import exportComponent from "/src/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ac555f04"],['__file',"src/views/pre/survey/components/Title.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "ac555f04"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('ac555f04', __exports__)) {
    console.log('reload')
    api.reload('ac555f04', __exports__)
  }
  
  module.hot.accept("./Title.vue?vue&type=template&id=ac555f04&scoped=true", () => {
    console.log('re-render')
    api.rerender('ac555f04', render)
  })

}


export default __exports__